import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';

export function Content() {
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];
  const currentSubStep =
    currentStep.type === 'step'
      ? currentStep.subSteps[ctx.state.currentSubStepIndex]
      : null;
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        form.handleSubmit();
      }}
      className="w-full h-full overflow-y-auto p-4 md:p-0 md:mt-10">
      {currentStep.type === 'summary' && currentStep.content}
      {currentStep.type === 'step' && currentSubStep?.content}
    </form>
  );
}
